import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { INGREDIENT_KEYWORDS_QUERY } from '../graphql/queries'
import { FETCH_INGREDIENT_KEYWORDS } from '../redux/action-types'
import { cleanupFetchIngredientKeywords } from '../redux/actions'

const useIngredientKeywordsQuery = (ingredientId, lazy) => {
  const dispatch = useDispatch()

  const { isLoading, error, data } = useSelector(
    store => store.ingredients.ingredient?.keywords?.supporting || {},
  )

  const refetch = useCallback(
    ingredientId =>
      apolloService.query(
        INGREDIENT_KEYWORDS_QUERY,
        { ingredientId },
        dispatch,
        FETCH_INGREDIENT_KEYWORDS,
      ),
    [dispatch],
  )

  useCleanupRedux(cleanupFetchIngredientKeywords)

  useEffect(() => {
    if (!lazy) {
      refetch(ingredientId)
    }
  }, [ingredientId, lazy, refetch])

  const queryState = { isLoading, error, data }
  return lazy ? [refetch, queryState] : queryState
}

export default useIngredientKeywordsQuery
